<template>
  <div
    id="app"
    class="o-typography"
    :class="{ 't-kids': isKidsTheme, 'is-loading': loading }"
  >
    <ui-navbar
      :class="{ 'is-visible': !drawerVisible }"
      @showProfiles="showProfiles"
      @showDrawer="showDrawer"
    ></ui-navbar>
    <ui-navigation-drawer
      ref="navigationDrawer"
      :class="{ 'is-visible': drawerVisible }"
      @showProfiles="showProfiles"
      @close="closeDrawer"
    ></ui-navigation-drawer>
    <router-view
      class="o-page"
      :class="{ 'is-blurred': drawerVisible }"
    ></router-view>
    <ui-footer :class="{ 'is-blurred': drawerVisible }"></ui-footer>
    <ui-profiles ref="profiles"></ui-profiles>
    <ui-modal></ui-modal>
  </div>
</template>
<script>
  import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
  import {
    UiFooter,
    UiModal,
    UiNavbar,
    UiNavigationDrawer,
    UiProfiles,
  } from '@/index/components';
  import { layoutMixin } from '@/index/shared/mixins';
  import { NavigationContextManager } from '@/shared/utils/accessibility';

  const ONE_TRUST_VISIBILITY_CLASS = 'onetrust-visible';

  export default {
    components: {
      UiFooter,
      UiModal,
      UiNavbar,
      UiNavigationDrawer,
      UiProfiles,
    },
    mixins: [
      layoutMixin,
    ],
    data() {
      return {
        drawerWrapperTarget: null,
        manager: this.$services.resolve('liveManager'),
        drawerVisible: false,
        subscriber: this.$services.resolve('subscriber'),
      };
    },
    computed: {
      isKidsTheme() {
        return this.subscriber.isKidsTheme;
      },
    },
    mounted() {
      this.drawerWrapperTarget = this.$refs.navigationDrawer.$el;
    },
    beforeDestroy() {
      document.body.classList.remove(ONE_TRUST_VISIBILITY_CLASS);
    },
    methods: {
      pageView() {
        this.loading = false;
        this.manager.stopUpdate();
        document.body.classList.add(ONE_TRUST_VISIBILITY_CLASS);
        this.$deferredLoader.appReady.resolve();
      },
      showDrawer() {
        if (!this.drawerVisible) {
          this.drawerVisible = true;
          disableBodyScroll(this.drawerWrapperTarget);

          this.$nextTick(() => NavigationContextManager.pushContext(this.drawerWrapperTarget, this.closeDrawer));
        }
      },
      showProfiles(options = {}) {
        this.$refs.profiles.show(options);
      },
      closeDrawer() {
        if (this.drawerVisible) {
          this.drawerVisible = false;
          enableBodyScroll(this.drawerWrapperTarget);
          NavigationContextManager.popContext();
        }
      },
    },
  };
</script>
